import React from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";

/**
 * One-tap WhatsApp share button.
 *
 * Props:
 *  - message: plain text (or with %0A newlines) that will be pre-filled in WhatsApp
 *  - variant: "primary" (WhatsApp green) | "outline" (subtle) | "dark"
 *  - size: sm | md | lg
 *  - testId
 *  - label (optional override, default "Share on WhatsApp")
 *
 * Uses the standard wa.me URL — opens the native app on mobile, WhatsApp Web on desktop.
 */
export default function ShareOnWhatsApp({
  message,
  variant = "primary",
  size = "md",
  testId = "share-whatsapp-btn",
  label = "Share on WhatsApp",
  className = "",
}) {
  const href = `https://wa.me/?text=${encodeURIComponent(message)}`;
  const styles = {
    primary: "bg-[#D4A24C] hover:bg-[#C9962F] text-black",
    outline: "border border-[#D4A24C] text-[#D4A24C] hover:bg-gold-50 bg-[#0A0A0A]",
    dark: "bg-[#0A0A0A] text-[#B5842A] hover:bg-[#141414]",
  }[variant];
  const padding = size === "lg" ? "px-6 py-6 text-base" : size === "sm" ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm";
  return (
    <Button
      asChild
      className={`${styles} ${padding} font-manrope font-semibold rounded-md ${className}`}
      data-testid={testId}
    >
      <a href={href} target="_blank" rel="noopener noreferrer">
        <MessageCircle className="w-4 h-4 mr-2" /> {label}
      </a>
    </Button>
  );
}
